import { render, staticRenderFns } from "./monthly-score.vue?vue&type=template&id=b0bdc5c4&"
import script from "./monthly-score.vue?vue&type=script&lang=js&"
export * from "./monthly-score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports